export const getBankId = () => {
  const param = getParam('bank_id') || 'CB';
  if (!param) throw new Error('No bank id');
  return param;
};

export const getAccessToken = () => {
  const param = getParam('access_token');
  if (!param) throw new Error('No access token');
  return param;
};

export const getBrandId = () => {
  const param = getParam('brand_id');
  if (!param) throw new Error('No brand id');
  return param;
};

// optional pram
export const getUserTrackingId = () => getParam('user_tracking_id');

// optional param
export const getIsSME = () => getParam('is_sme') === 'true';

// Params for VA
export const getTemplate = () => getParam('template');
export const getApp = () => getParam('app');

const getParam = (param) => {
  const params = new URLSearchParams(window.location.hash.substring(1));
  return params.get(param);
};
